window.ZeptoPersonalizer = window.ZeptoPersonalizer || {};
window.ZeptoPersonalizer.redirectToCart = false;

window.addEventListener("pplrAddToCartCompleted", async () => {
  console.log("🔥 Zepto → open Allure drawer");

  try {
    // 1. Fetch full cart JSON
    const cart = await fetch('/cart.js').then(r => r.json());

    // 2. Fetch Allure drawer sections
    const sections = await fetch(
      window.location.pathname + '?sections=cart-drawer,cart-items&lazyload=false'
    ).then(r => r.json());

    // 3. Build the same payload your bd-product-card uses
    const cartData = {
      ...cart,
      sections,
      params: []
    };

    // 4. Fire Allure’s native event
    document.dispatchEvent(new CustomEvent('l:product:added', {
      detail: { cartData }
    }));

    // 5. Fire EventBus update event
    window.themeCore.EventBus.emit("cart:updated", cartData);

    // 6. Open drawer
    window.themeCore.EventBus.emit("cart:drawer:open");

  } catch (err) {
    console.error("Zepto → drawer error:", err);
  }
});
